import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase";
import { useAuth } from "../hooks/useAuth";
import ProfileDropdown from "./ProfileDropdown";

export default function Navbar() {
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [userRole, setUserRole] = useState(null);
  const { user } = useAuth(); // 🔑 Asegúrate de que `useAuth` devuelve `user`

  const isListingDetail = location.pathname.startsWith("/oferta/");

  // Detectar scroll
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Obtener role del usuario desde Firestore
  useEffect(() => {
    const obtenerRolUsuario = async () => {
      if (!user?.email) return;
      try {
        const querySnapshot = await getDocs(collection(db, "users"));
        querySnapshot.forEach((docSnap) => {
          const data = docSnap.data();
          if (data.email === user.email) {
            setUserRole(data.role);
          }
        });
      } catch (err) {
        console.error("Error obteniendo el rol del usuario:", err);
      }
    };
    obtenerRolUsuario();
  }, [user?.email]);

  // Selección del logo según el rol
  const logoSrc = userRole === "premium" ? "/PREMIUM.png" : "/noltrade_gpt.png";

  // ✅ Sticky navbar (solo en detalle)
  if (isListingDetail && scrolled) {
    return (
      <header className="flex items-center justify-between px-6 py-4 border-b bg-white sticky top-0 z-50 shadow-sm transition-all duration-300 transform animate-fade-in">
        <div className="flex items-center gap-8">
          <Link to="/">
            <img src={logoSrc} alt="Noltrade Logo" className="h-12" />
          </Link>
          <nav className="flex gap-4 items-center">
            <a href="#resumen" className="text-sm text-gray-800 font-medium hover:text-yellow-500 transition">Resumen</a>
            <a href="#metricas" className="text-sm text-gray-800 font-medium hover:text-yellow-500 transition">Estadísticas</a>
            <a href="#info" className="text-sm text-gray-800 font-medium hover:text-yellow-500 transition">Detalles</a>
          </nav>
        </div>
        {userRole === "premium" || userRole === "admin" ? (
        <button
          onClick={() => {
            // Aquí podrías abrir el chat, modal o navegar
            // por ejemplo: navigate("/chat?vendedorId=123")
            console.log("Iniciar chat con el vendedor");
          }}
          className="text-white bg-yellow-500 hover:bg-yellow-600 px-4 py-1.5 rounded-md text-sm font-medium shadow-sm hover:shadow-md transition duration-200"
        >
          Contactar con el vendedor
        </button>
      ) : (
        <Link
          to="/premium"
          className="text-white bg-yellow-500 hover:bg-yellow-600 px-4 py-1.5 rounded-md text-sm font-medium shadow-sm hover:shadow-md transition duration-200"
        >
          Acceder a todos los detalles →
        </Link>
      )}

      </header>
    );
  }

  // ✅ Navbar por defecto
  return (
    <header className="flex items-center justify-between px-6 py-4 border-b bg-white sticky top-0 z-50">
      <div className="flex items-center gap-8">
        <Link to="/">
          <img src={logoSrc} alt="Noltrade Logo" className="h-12" />
        </Link>
        <nav className="flex gap-4 items-center">
          <Link to="/" className="text-gray-600 hover:text-[#f0b632] transition-colors">Listados</Link>
          <Link to="/ofertas" className="text-gray-600 hover:text-[#f0b632] transition-colors">Mis ofertas</Link>
          <Link to="/buzon" className="text-gray-600 hover:text-[#f0b632] transition-colors">Buzón</Link>
          <Link to="/publicar" className="ml-2 text-white bg-black hover:bg-neutral-800 px-4 py-1.5 rounded-md text-sm font-medium shadow-sm hover:shadow-md transition duration-200">Sube tu oferta</Link>
          {userRole !== "premium" && userRole !== "admin" && (
            <Link
              to="/premium"
              className="ml-2 text-white bg-[#f0b632] hover:bg-yellow-500 px-4 py-1.5 rounded-md text-sm font-medium shadow-sm hover:shadow-md transition duration-200"
            >
              Únete a Premium
            </Link>
          )}

        </nav>
      </div>
      <ProfileDropdown />
    </header>
  );
}
